(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!customElements.get('sds-shipping-progress')) {
    class SdsShippingProgress extends HTMLElement {
      static get observedAttributes() {
        return ['total-price', 'threshold-cents'];
      }

      constructor() {
        super();
        this.handleCartChange = this.handleCartChange.bind(this);
      }

      connectedCallback() {
        document.addEventListener('cart:change', this.handleCartChange);
        this.renderProgress();
      }

      disconnectedCallback() {
        document.removeEventListener('cart:change', this.handleCartChange);
      }

      attributeChangedCallback() {
        if (this.isConnected) this.renderProgress();
      }

      handleCartChange(event) {
        const cart = event.detail?.cart;
        if (!cart?.items) return;

        const shippingTotal = cart.items
          .filter((item) => item.requires_shipping)
          .reduce((sum, item) => sum + item.final_line_price, 0);
        const cartDiscount = (cart.cart_level_discount_applications || [])
          .reduce((sum, allocation) => sum + (allocation.discount_application?.total_allocated_amount || 0), 0);

        this.setAttribute('total-price', Math.max(shippingTotal - cartDiscount, 0));
      }

      renderProgress() {
        const threshold = Number(this.getAttribute('threshold-cents')) || 0;
        const total = Number(this.getAttribute('total-price')) || 0;
        if (!threshold) return;

        const progress = Math.min(Math.max((total / threshold) * 100, 0), 100);
        const remaining = Math.max(threshold - total, 0);
        const formatter = new Intl.NumberFormat(Shopify.locale, {
          style: 'currency',
          currency: Shopify.currency.active,
          maximumFractionDigits: 2
        });
        const message = total >= threshold
          ? this.dataset.reachedMessage
          : this.dataset.unreachedMessage.replace(/\{\{.*?\}\}/g, formatter.format(remaining / 100));
        const messageElement = this.querySelector('[data-shipping-message]');
        const progressElement = this.querySelector('[data-shipping-fill]');
        const progressBar = this.querySelector('[role="progressbar"]');

        if (messageElement) messageElement.innerHTML = message;
        if (progressElement) progressElement.style.setProperty('--sds-cart-progress', `${progress}%`);
        if (progressBar) progressBar.setAttribute('aria-valuenow', String(Math.round(progress)));
      }
    }

    customElements.define('sds-shipping-progress', SdsShippingProgress);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pipeline-mobile-menu"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sds-mobile-menu')) {
    customElements.define('sds-mobile-menu', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.drawer = this.closest('x-drawer');
        this.desktop = window.matchMedia('(min-width: 1000px)');
        this.updateMenuToggles();
        this.syncHeader();
        document.addEventListener('shopify:section:load', () => this.updateMenuToggles(), options);
        this.drawer?.addEventListener('click', (event) => this.onClick(event), options);
        this.drawer?.addEventListener('dialog:before-show', () => this.syncHeader(), options);
        const announcement = document.querySelector('.shopify-section--announcement-bar .announcement-bar__carousel');
        announcement?.addEventListener('carousel:change', () => this.syncAnnouncement(), options);
        this.addEventListener('keydown', (event) => this.onKeydown(event), options);
        this.addEventListener('shopify:block:select', (event) => {
          const tab = this.tabs.find((item) => item.dataset.blockId === event.detail.blockId);
          if (tab) this.selectTab(tab);
        }, options);
        this.drawer?.addEventListener('dialog:after-hide', () => {
          this.resetSubmenus();
          const search = this.querySelector('.sds-mobile-menu__search');
          if (search) search.hidden = true;
          this.drawer.querySelector('[data-menu-search-toggle]')?.setAttribute('aria-expanded', 'false');
        }, options);
        this.drawer?.addEventListener('dialog:after-show', () => {
          if (this.desktop.matches) this.drawer.hide();
        }, options);
        this.desktop.addEventListener('change', () => {
          this.updateMenuToggles();
          if (this.desktop.matches) this.drawer?.hide();
        }, options);
      }

      disconnectedCallback() {
        this.controller?.abort();
        document.querySelectorAll('[data-pipeline-menu-toggle]').forEach((toggle) => toggle.setAttribute('aria-controls', 'sidebar-menu'));
      }

      updateMenuToggles() {
        const target = this.desktop.matches ? 'sidebar-menu' : 'pipeline-mobile-menu';
        document.querySelectorAll('[data-pipeline-menu-toggle]').forEach((toggle) => {
          toggle.setAttribute('aria-controls', target);
          toggle.setAttribute('aria-expanded', String(document.getElementById(target)?.hasAttribute('open') ?? false));
        });
      }

      copyColorScheme(source, target) {
        if (!source || !target) return;
        Array.from(target.classList).filter((name) => name === 'color-scheme' || name.startsWith('color-scheme--')).forEach((name) => target.classList.remove(name));
        Array.from(source.classList).filter((name) => name === 'color-scheme' || name.startsWith('color-scheme--')).forEach((name) => target.classList.add(name));
      }

      syncHeader() {
        const header = document.querySelector('x-header.header');
        const brand = this.drawer?.querySelector('[data-menu-brand]');
        if (header && this.drawer?.dataset.matchHeader === 'true') this.copyColorScheme(header, brand);
        if (header && this.drawer?.dataset.customLogo !== 'true') {
          const source = header.querySelector('.header__logo-image:not(.header__logo-image--transparent), .header__logo-text');
          const logo = this.drawer.querySelector('[data-menu-logo]');
          if (source && logo) {
            const copy = source.cloneNode(true);
            copy.removeAttribute('id');
            copy.className = source.tagName === 'IMG' ? 'sds-mobile-menu__logo-image' : 'sds-mobile-menu__logo-text';
            logo.replaceChildren(copy);
          }
        }
        this.syncAnnouncement();
      }

      syncAnnouncement() {
        const row = this.drawer?.querySelector('[data-menu-announcement]');
        if (!row || this.drawer.dataset.matchAnnouncement !== 'true') return;
        const source = document.querySelector('.shopify-section--announcement-bar .announcement-bar');
        const message = source?.querySelector('.announcement-bar__carousel .is-selected') || source?.querySelector('.announcement-bar__carousel > p');
        row.hidden = !message;
        if (!message) return;
        this.copyColorScheme(source, row);
        row.style.setProperty('--sds-menu-announcement-font-size', getComputedStyle(source).getPropertyValue('--announcement-bar-font-size').trim() || '11px');
        row.querySelector('[data-menu-announcement-text]').replaceChildren(...Array.from(message.childNodes, (node) => node.cloneNode(true)));
      }

      onClick(event) {
        const searchToggle = event.target.closest('[data-menu-search-toggle]');
        if (searchToggle && this.drawer?.contains(searchToggle)) {
          const search = this.querySelector('.sds-mobile-menu__search');
          if (!search) return;
          search.hidden = !search.hidden;
          searchToggle.setAttribute('aria-expanded', String(!search.hidden));
          if (!search.hidden) search.querySelector('input[type="search"]')?.focus({ preventScroll: true });
          this.scrollBodyToTop();
          return;
        }
        const tab = event.target.closest('[role="tab"]');
        if (tab && this.contains(tab)) {
          this.selectTab(tab);
          return;
        }
        const opener = event.target.closest('[data-menu-open]');
        if (opener && this.contains(opener)) {
          const panel = opener.closest('[role="tabpanel"]');
          const submenu = document.getElementById(opener.getAttribute('aria-controls'));
          if (!submenu || !panel?.contains(submenu)) return;
          panel.querySelector('[data-menu-main]').hidden = true;
          submenu.hidden = false;
          opener.setAttribute('aria-expanded', 'true');
          submenu.querySelector('[data-menu-back]')?.focus({ preventScroll: true });
          this.scrollBodyToTop();
          return;
        }
        const back = event.target.closest('[data-menu-back]');
        if (back && this.contains(back)) {
          const submenu = back.closest('[data-menu-submenu]');
          submenu.hidden = true;
          submenu.closest('[role="tabpanel"]').querySelector('[data-menu-main]').hidden = false;
          const opener = document.getElementById(back.dataset.returnTo);
          opener?.setAttribute('aria-expanded', 'false');
          opener?.focus({ preventScroll: true });
          this.scrollBodyToTop();
        }
      }

      onKeydown(event) {
        const tab = event.target.closest('[role="tab"]');
        if (!tab || !this.tabs.includes(tab)) return;
        const index = this.tabs.indexOf(tab);
        const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
        let nextIndex;
        if (event.key === 'ArrowRight') nextIndex = (index + direction + this.tabs.length) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - direction + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === undefined) return;
        event.preventDefault();
        this.selectTab(this.tabs[nextIndex], true);
      }

      selectTab(selectedTab, focus = false) {
        this.resetSubmenus();
        this.tabs.forEach((tab) => {
          const selected = tab === selectedTab;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          const panel = document.getElementById(tab.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });
        if (focus) selectedTab.focus({ preventScroll: true });
        selectedTab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
        this.scrollBodyToTop();
      }

      resetSubmenus() {
        this.querySelectorAll('[data-menu-submenu]').forEach((submenu) => submenu.hidden = true);
        this.querySelectorAll('[data-menu-main]').forEach((panel) => panel.hidden = false);
        this.querySelectorAll('[data-menu-open]').forEach((opener) => opener.setAttribute('aria-expanded', 'false'));
        this.querySelectorAll('details[open]').forEach((details) => details.open = false);
      }

      scrollBodyToTop() {
        this.drawer?.shadowRoot?.querySelector('[part="body"]')?.scrollTo({ top: 0, behavior: 'instant' });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sds-about-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sds-about-story')) {
    class SDSAboutStory extends HTMLElement {
      connectedCallback() {
        if (this.dataset.bound === 'true') return;
        this.dataset.bound = 'true';

        const elements = [...this.querySelectorAll('[data-reveal]')];
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
          elements.forEach((element) => element.classList.add('is-visible'));
          return;
        }

        this.setAttribute('data-ready', '');
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.16 });

        elements.forEach((element) => observer.observe(element));
      }
    }

    customElements.define('sds-about-story', SDSAboutStory);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sds-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sds-bundle-builder')) {
    class SdsBundleBuilder extends HTMLElement {
      connectedCallback() {
        if (this.isReady) return;
        this.isReady = true;
        this.minimumItems = Number(this.dataset.minimumItems || 3);
        this.discountPercentage = Number(this.dataset.discountPercentage || 15);
        this.discountMultiplier = Number(this.dataset.discountMultiplier || 85) / 100;
        this.currency = this.dataset.currency || 'CHF';
        this.selectedItems = new Map();
        this.isSubmitting = false;
        this.summaryInView = false;
        this.setupSummaryVisibility();
        this.setupTabs();
        this.setupCards();
        this.submitButton = this.querySelector('[data-bundle-submit]');
        this.submitButton?.addEventListener('click', () => this.addBundleToCart());
        this.render();
      }

      setupSummaryVisibility() {
        const catalog = this.querySelector('.sds-bundle-builder__catalog');
        if (!catalog || !('IntersectionObserver' in window)) {
          this.summaryInView = true;
          this.updateSummaryVisibility();
          return;
        }

        this.summaryObserver = new IntersectionObserver((entries) => {
          this.summaryInView = entries.some((entry) => entry.isIntersecting);
          this.updateSummaryVisibility();
        }, { rootMargin: '0px 0px -15% 0px' });
        this.summaryObserver.observe(catalog);
      }

      updateSummaryVisibility() {
        this.classList.toggle('is-summary-visible', this.summaryInView || this.selectedItems.size > 0);
      }

      setupTabs() {
        const tabs = [...this.querySelectorAll('[data-bundle-tab]')];
        const panels = [...this.querySelectorAll('[data-bundle-panel]')];

        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activateTab(tab, tabs, panels));
          tab.addEventListener('keydown', (event) => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            let nextIndex = index;
            if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = tabs.length - 1;
            this.activateTab(tabs[nextIndex], tabs, panels);
            tabs[nextIndex].focus();
          });
        });
      }

      activateTab(activeTab, tabs, panels) {
        tabs.forEach((tab) => {
          const isActive = tab === activeTab;
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
        });

        panels.forEach((panel) => {
          panel.hidden = panel.id !== activeTab.dataset.target;
        });
      }

      setupCards() {
        this.querySelectorAll('[data-bundle-card]').forEach((card) => {
          const select = card.querySelector('[data-variant-select]');
          const button = card.querySelector('[data-bundle-toggle]');
          if (!select || !button || button.disabled) return;

          const updateCardPrice = () => {
            const option = select.options[select.selectedIndex];
            const price = Number(option?.dataset.price);
            const priceElement = card.querySelector('[data-bundle-card-price]');
            if (priceElement && Number.isFinite(price)) priceElement.textContent = this.formatMoney(price);
          };

          const updateAvailability = () => {
            if (this.selectedItems.has(card.dataset.cardKey)) return;
            button.disabled = !select.value;
          };

          select.addEventListener('change', () => {
            updateCardPrice();
            const existing = this.selectedItems.get(card.dataset.cardKey);
            if (existing) {
              this.selectedItems.set(card.dataset.cardKey, this.itemFromCard(card));
              this.render();
            } else {
              updateAvailability();
            }
          });

          button.addEventListener('click', () => {
            const key = card.dataset.cardKey;
            if (this.selectedItems.has(key)) {
              this.selectedItems.delete(key);
            } else {
              if (!select.value) {
                select.focus();
                return;
              }
              this.selectedItems.set(key, this.itemFromCard(card));
            }
            this.render();
          });

          updateAvailability();
        });
      }

      itemFromCard(card) {
        const select = card.querySelector('[data-variant-select]');
        const option = select.options[select.selectedIndex];
        return {
          key: card.dataset.cardKey,
          card,
          id: option.value,
          price: Number(option.dataset.price || 0),
          productTitle: card.dataset.productTitle,
          variantTitle: option.dataset.variantTitle || ''
        };
      }

      formatMoney(cents) {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: this.currency
        }).format(cents / 100);
      }

      render() {
        const items = [...this.selectedItems.values()];
        const count = items.length;
        const remaining = Math.max(this.minimumItems - count, 0);
        const regularTotal = items.reduce((sum, item) => sum + item.price, 0);
        const hasUnlockedDiscount = count >= this.minimumItems;
        const bundleTotal = hasUnlockedDiscount ? Math.round(regularTotal * this.discountMultiplier) : regularTotal;
        const saving = regularTotal - bundleTotal;
        const progress = Math.min((count / this.minimumItems) * 100, 100);
        this.classList.toggle('has-selection', count > 0);
        this.classList.toggle('is-qualified', hasUnlockedDiscount);

        this.querySelectorAll('[data-bundle-card]').forEach((card) => {
          const isSelected = this.selectedItems.has(card.dataset.cardKey);
          const button = card.querySelector('[data-bundle-toggle]');
          const select = card.querySelector('[data-variant-select]');
          card.classList.toggle('is-selected', isSelected);
          if (button && !button.dataset.permanentlyDisabled) {
            button.textContent = isSelected ? this.dataset.removeLabel : this.dataset.addLabel;
            button.setAttribute('aria-pressed', String(isSelected));
            button.setAttribute('aria-label', `${isSelected ? this.dataset.removeLabel : this.dataset.addLabel}: ${card.dataset.productTitle}`);
            button.disabled = !isSelected && !select?.value;
          }
        });

        const progressLabel = this.dataset.progressLabel
          .replace('__count__', count)
          .replace('__minimum__', this.minimumItems);
        this.querySelector('[data-bundle-progress]').textContent = progressLabel;
        this.querySelector('[data-bundle-progress-bar]').style.width = `${progress}%`;

        let message = this.dataset.unlockedLabel;
        if (remaining === 1) message = this.dataset.remainingOneLabel;
        if (remaining > 1) message = this.dataset.remainingOtherLabel.replace('__count__', remaining);
        this.querySelector('[data-bundle-message]').textContent = message;

        const itemsContainer = this.querySelector('[data-bundle-items]');
        itemsContainer.replaceChildren(...items.map((item) => {
          const chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'sds-bundle-summary__chip';
          const itemLabel = item.variantTitle && item.variantTitle !== 'Default Title'
            ? `${item.productTitle} · ${item.variantTitle}`
            : item.productTitle;
          chip.textContent = `${itemLabel} ×`;
          chip.setAttribute('aria-label', `${this.dataset.removeLabel}: ${itemLabel}`);
          chip.addEventListener('click', () => {
            this.selectedItems.delete(item.key);
            this.render();
          });
          return chip;
        }));

        this.querySelector('[data-bundle-regular-total]').textContent = this.formatMoney(regularTotal);
        this.querySelector('[data-bundle-saving]').textContent = `${saving > 0 ? '−' : ''}${this.formatMoney(saving)}`;
        this.querySelector('[data-bundle-total]').textContent = this.formatMoney(bundleTotal);
        if (this.submitButton) this.submitButton.disabled = this.isSubmitting || count < this.minimumItems;
        this.updateSummaryVisibility();
      }

      async addBundleToCart() {
        if (this.isSubmitting || this.selectedItems.size < this.minimumItems || !this.submitButton) return;
        const status = this.querySelector('[data-bundle-status]');
        this.isSubmitting = true;
        this.submitButton.disabled = true;
        this.submitButton.setAttribute('aria-busy', 'true');
        this.submitButton.textContent = this.dataset.addingLabel;
        status.textContent = '';

        try {
          const response = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: [...this.selectedItems.values()].map((item) => ({
                id: Number(item.id),
                quantity: 1
              }))
            })
          });

          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          this.isSubmitting = false;
          this.submitButton.removeAttribute('aria-busy');
          status.textContent = this.dataset.errorLabel;
          this.submitButton.textContent = this.dataset.submitLabel;
          this.render();
        }
      }
    }

    customElements.define('sds-bundle-builder', SdsBundleBuilder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sds-women-world"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sds-women-world')) {
    customElements.define('sds-women-world', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('[data-women-video]');
        this.videoToggle = this.querySelector('[data-women-video-toggle]');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        const revealVideo = () => {
          if (!this.reducedMotion.matches) this.video?.classList.add('is-ready');
        };

        if (this.video?.readyState >= 3) revealVideo();
        else this.video?.addEventListener('canplay', revealVideo, { once: true });

        this.videoToggle?.addEventListener('click', () => this.toggleVideo());

        const revealItems = this.querySelectorAll('[data-women-reveal]');
        if (!('IntersectionObserver' in window) || this.reducedMotion.matches) {
          this.video?.pause();
          this.setVideoState(true);
          return;
        }

        this.revealObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

        this.classList.add('is-reveal-ready');
        revealItems.forEach((item) => this.revealObserver.observe(item));
      }

      disconnectedCallback() {
        this.revealObserver?.disconnect();
      }

      toggleVideo() {
        if (!this.video) return;
        if (this.video.paused) {
          this.video.play();
          this.setVideoState(false);
        } else {
          this.video.pause();
          this.setVideoState(true);
        }
      }

      setVideoState(paused) {
        if (!this.videoToggle) return;
        const label = paused ? this.videoToggle.dataset.playLabel : this.videoToggle.dataset.pauseLabel;
        this.videoToggle.dataset.paused = paused ? 'true' : 'false';
        this.videoToggle.setAttribute('aria-label', label);
        const labelElement = this.videoToggle.querySelector('[data-women-video-label]');
        if (labelElement) labelElement.textContent = label;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
